import React, { useCallback, useEffect, useState } from 'react';
import {
  getPossibleChartTypes,
  CHART_ICON
} from '@nile/reports/src/modules/charts/utils/chart-transformation';
import { getEntityIcon } from '@nile/reports/src/modules/charts/utils/chart-transformation/ChartUtil';
import { getTranslatedText } from '@nile/components';
import {
  ActionList,
  Badge,
  Button,
  Popover,
  TextStyle,
  Tippy
} from '@superops/ui-design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { isEmpty } from 'lodash';
import { EntityBadge } from './styles';
import { DEPARTMENT, SITE } from '@nile/reports/src/modules/charts/constants';

function GridHeader(props) {
  const {
    setOpenChart,
    chart,
    isExport,
    isViewOnly,
    reportLayout,
    removeElement,
    isTvDashboard,
    dispatch,
    showDelete,
    ischartSwitchBtnVisible = null,
    insightChartData,
    disableCursor
  } = props;

  const intl = useIntl();

  const [active, setActive] = useState(false);

  const [possibleChartType, setPossibleChartType] = useState([]);

  const toggleActive = useCallback(
    () => setActive((prevState) => !prevState),
    []
  );
  const getChartTypes = () => {
    const possibleType = getPossibleChartTypes(
      chart?.metrics?.length,
      chart?.groupBy?.length,
      chart?.entity
    ).map((chrt) => ({
      ...chrt,
      value: chrt.name
    }));

    setPossibleChartType(possibleType);
  };

  const chartTypeHandler = (type) => {
    const updatedReportLayout = reportLayout.map((el) => {
      if (el.chart.chartId === chart.chartId) {
        return {
          ...el,
          chart: {
            ...el.chart,
            defaultChartType: type
          }
        };
      }
      return el;
    });
    dispatch({ type: 'updateLayout', layout: updatedReportLayout });
    setActive(false);
  };

  const getBtnTxt = () => {
    const chrtType = possibleChartType.find(
      (chrt) => chrt.name === chart?.defaultChartType
    );
    return chrtType;
  };
  const icon = getBtnTxt();

  const showChartSwitchBtn =
    ischartSwitchBtnVisible ??
    (!!possibleChartType?.length &&
      chart?.defaultChartType !== 'NUMBER' &&
      isViewOnly);

  useEffect(() => {
    getChartTypes();
  }, []);

  return (
    <div className="gridHeader nonDraggable">
      <div
        className={`fx actr g10 ellipsis header insightChartData ${!disableCursor &&
          'ptr'} `}
      >
        <div
          className="fx fx2 actr g10 ellipsis p1520"
          onClick={() => !isExport && !isTvDashboard && setOpenChart(chart)}
        >
          {chart?.defaultChartType !== DEPARTMENT &&
            chart?.defaultChartType !== SITE && (
              <EntityBadge
                className={disableCursor && 'cursor-default'}
                color={getEntityIcon(chart?.entity).badgeColor}
              >
                {getEntityIcon(chart?.entity).icon}
              </EntityBadge>
            )}
          <div className="fx2 d-in">
            <div className="fx actr">
              {isEmpty(chart?.description?.trim()) ? (
                <div className="fx actr">
                  <div
                    className={`ellipsis reportName chart-title ${disableCursor &&
                      'cursor-default'}`}
                  >
                    {chart?.defaultChartType == DEPARTMENT ||
                    chart?.defaultChartType == SITE
                      ? insightChartData?.data?.name
                      : chart?.name || (
                          <TextStyle variation="subdued">
                            <FormattedMessage id="app.noData.message" />
                          </TextStyle>
                        )}
                  </div>
                </div>
              ) : (
                <Tippy
                  html={
                    <div className="p10 bshadow rounded-4px bg-white">
                      <TextStyle>{chart?.description}</TextStyle>
                    </div>
                  }
                  allowHTML
                  theme="light"
                  position="bottom-start"
                  className="fximp"
                >
                  <div className="fx actr">
                    <div
                      className={`ellipsis reportName chart-title ${disableCursor &&
                        'cursor-default'}`}
                    >
                      {chart?.name || (
                        <TextStyle variation="subdued">
                          <FormattedMessage id="app.noData.message" />
                        </TextStyle>
                      )}
                    </div>
                    {!isViewOnly && chart?.systemChart && (
                      <div className="mlr10 fx actr">
                        <Badge size="medium">
                          <TextStyle weight="Medium">
                            {getTranslatedText(intl, 'common.label.default')}
                          </TextStyle>
                        </Badge>
                      </div>
                    )}
                    <div className="flex-center mlr10">
                      <SVGIcon name="MenuBurgerSquare" />
                    </div>
                  </div>
                </Tippy>
              )}
            </div>
          </div>
        </div>
        {(showChartSwitchBtn || showDelete) && (
          <div className="fx jend p1520">
            {showChartSwitchBtn && (
              <div
                superid="chartType"
                className={
                  isViewOnly ? 'visibilityActions' : ' visibilityActions mr30'
                }
              >
                <Popover
                  active={active}
                  preferredAlignment="right"
                  activator={
                    <Button
                      onClick={toggleActive}
                      icon={
                        <SVGIcon
                          name={CHART_ICON[(icon && icon.name) || 'DOUGHNUT']}
                          size="lg"
                        />
                      }
                    />
                  }
                  onClose={toggleActive}
                >
                  <ActionList
                    actionRole="menuitem"
                    items={possibleChartType.map((chrt) => ({
                      ...chrt,
                      content: (
                        <div title={chrt?.label} className="fx actr g10">
                          <SVGIcon
                            name={CHART_ICON[chrt.name || 'DOUGHNUT']}
                            size="lg"
                          />
                          <TextStyle>{chrt.label}</TextStyle>
                        </div>
                      ),
                      onAction: () => chartTypeHandler(chrt.name)
                    }))}
                  />
                </Popover>
              </div>
            )}
            {showDelete && (
              <div className="visibilityAction">
                <div className="ml8 ptr" onClick={removeElement}>
                  <SVGIcon name="Delete" />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default GridHeader;
